module.exports = __webpack_public_path__ + "img/Group116.6a63b35f.png";